import * as React from "react";
import { connect } from "react-redux";
import fileSaver from "file-saver";
import PropTypes from "prop-types";
import * as storage from "../../coraWebComponents/utils/storage";
import withRouter from "../../coraWebComponents/utils/withRouter";
import "./User.scss";

// cora web components
import Dialog from "../../coraWebComponents/dialogs/Dialog";
import Slide from "../../coraWebComponents/animation/Slide";
import ManualPDF from "../../coraWebComponents/navigation/ManualPDF";
import BadgeContainer from "../../coraWebComponents/BadgeContainer";

// actions
import * as spravyActions from "../../actions/spravyActions";
import * as manualsActions from "../../actions/manualsActions";

// Prop types
import odberatelPropTypes from "../../propTypes/odberatelPropTypes";
import userPropTypes from "../../propTypes/userPropTypes";

// Routes
import Routes from "../../constants/Routes";

class User extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      showInfo: false,
      showNotifikacie: false,
      isManualDialogOpen: false,
      isConfirmDialogOpen: false,
    };
  }
  handleSettings = () => this.props.navigate(Routes.FORM_SETTINGS);
  handlenInitIcon = () => this.props.navigate(Routes.ODBERATEL);
  handleNapoveda = () => this.props.navigate(Routes.DODAVATEL);
  handleSpravy = () => this.props.navigate(Routes.SPRAVY);
  handleInfo = () => {
    this.setState({
      showInfo: true,
    });
  };
  handleCloseInfo = () => {
    this.setState({ showInfo: false });
  };
  handleManualDialogClose = () => {
    this.setState({
      isManualDialogOpen: false,
    });
  };
  handleConfirmDialogDownload = async () => {
    this.setState({
      isConfirmDialogOpen: false,
    });

    await this.props.getManual();

    const { manualBlob, manualFileName } = this.props;
    if (manualBlob) fileSaver.saveAs(manualBlob, manualFileName);
  };
  handleConfirmDialogZobrazit = () => {
    this.setState({
      isConfirmDialogOpen: false,
      isManualDialogOpen: true,
    });
  };
  handleConfirmDialogClose = () => {
    this.setState({
      isConfirmDialogOpen: false,
      isManualDialogOpen: false,
    });
  };
  handleToS = () => {
    this.setState({ isConfirmDialogOpen: true });
  };
  handleNotifikacie = () => {
    this.setState({
      showNotifikacie: true,
    });
  };
  handleCloseNotifikacie = () => {
    this.setState({ showNotifikacie: false });
  };
  handleLogout = () => {
    storage.removeUser();
    this.props.onSignOut();
  };
  genChildren = () => {
    const { user, getManual, manualBlob, manualFileName } = this.props;

    return (
      <ManualPDF
        manualProps={{
          hasList: false,
          user,
          manualBlob,
          manualFileName,
          manualTitle: "ZISportal_prirucka",
        }}
        getManual={getManual}
      />
    );
  };
  buildInicialy = () => {
    const { odberatel } = this.props;

    if (odberatel && odberatel.Skratka) {
      return odberatel.Skratka;
    }

    if (!odberatel || !odberatel.NAZOV) {
      return "x";
    }

    return `${odberatel.NAZOV.charAt(0)}`;
  };
  componentDidMount() {
    this.props.getCountNeprecitaneSpravy(-1);
  }

  render() {
    const {
      showInfo,
      showNotifikacie,
      isManualDialogOpen,
      isConfirmDialogOpen,
    } = this.state;
    const { countNeprecitaneSpravy, odberatel, user } = this.props;

    const infoOkno = (
      <div className="info-okno">
        <div className="nav_initials">
          <div
            className="settings k-icon k-i-cogs"
            onClick={this.handleSettings}
          />
          <div className="inicialization-icone" onClick={this.handlenInitIcon}>
            {this.buildInicialy()}
          </div>
        </div>

        <div className="example-2">
          {odberatel && (
            <div className="meno-user">
              <section>
                <p>
                  <strong>{odberatel.NAZOV}</strong>
                </p>
                <p>{odberatel.EMAIL1 || "e-mail"}</p>
                <p>{odberatel.TELEFON || "telefon"}</p>
              </section>
            </div>
          )}
          {this.props.userInfo}
        </div>

        <div className="nav_button_logout">
          <div className="ToS" onClick={this.handleToS}>
            <p>Príručka</p>
          </div>
          <div className="logout" onClick={this.handleLogout}>
            Odhlásiť sa
          </div>
        </div>
      </div>
    );

    const notifikacieOkno = (
      <div className="info-okno">Notifikácie Placeholder</div>
    );

    return (
      <>
        <div className="nav-user">
          <div className="firstContainer">
            <div className="prihlasenyWeb">
              {user?.Uzivatel?.N_UZ || "Prázdne meno"}
            </div>

            <BadgeContainer
              align={{ vertical: "top", horizontal: "start" }}
              className={
                countNeprecitaneSpravy !== 0 ? "" : "hide-badge-container"
              }
              size="small"
              shape="pill"
              cutoutBorder={true}
              content={countNeprecitaneSpravy}
            >
              <div className="k-icon k-i-envelop" onClick={this.handleSpravy} />
            </BadgeContainer>

            <div className="k-icon k-i-info" onClick={this.handleNapoveda} />
            <div className="k-icon k-i-user" onClick={this.handleInfo} />

            <Slide
              isOpen={showNotifikacie}
              onClose={this.handleCloseNotifikacie}
            >
              {notifikacieOkno}
            </Slide>
            <Slide isOpen={showInfo} onClose={this.handleCloseInfo}>
              {infoOkno}
            </Slide>
          </div>

          <div className="secondContainer">
            <div className="prihlasenyMobile">
              {user?.Uzivatel?.N_UZ || "Prázdne meno"}
            </div>
          </div>
        </div>

        <Dialog
          isOpen={isConfirmDialogOpen}
          onCancel={this.handleConfirmDialogZobrazit}
          onClose={this.handleConfirmDialogClose}
          onConfirm={this.handleConfirmDialogDownload}
          title="Prajete si dokument stiahnuť ?"
          confirmText="Stiahnuť"
          cancelText="Zobraziť"
          children={<></>}
        />
        <Dialog
          isOpen={isManualDialogOpen}
          title={"Používateľská príručka"}
          onClose={this.handleManualDialogClose}
          onConfirm={this.handleManualDialogClose}
          fullscreen={true}
          className={"fullscreen-report"}
          children={this.genChildren()}
        />
      </>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    countNeprecitaneSpravy: state.countNeprecitaneSpravy.data,
    isLoading: state.manual.isLoading,
    isOdberatelPicked: state.odberatel.isPicked,
    odberatel: state.odberatel.data,
    manualBlob: state.manual.file ? state.manual.file.blob : null,
    manualFileName:
      state.manual.file && state.manual.file.fileName
        ? state.manual.file.fileName
        : "ZISportal_prirucka.pdf",
    user: state.user.data,
  };
};

const mapDispatchToProps = (dispatch) => ({
  getCountNeprecitaneSpravy: (I_ORGAN) =>
    dispatch(spravyActions.getCountNeprecitaneSpravy(I_ORGAN)),
  getManual: () => dispatch(manualsActions.getManual()),
});

User.propTypes = {
  countNeprecitaneSpravy: PropTypes.number,
  getCountNeprecitaneSpravy: PropTypes.func,
  getManual: PropTypes.func,
  isLoading: PropTypes.bool,
  isOdberatelPicked: PropTypes.bool,
  odberatel: odberatelPropTypes.odberatel,
  manual: PropTypes.element,
  manualBlob: PropTypes.object,
  manualFileName: PropTypes.string,
  onSignOut: PropTypes.func.isRequired,
  user: userPropTypes.user,
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(User));
